import { getLocale } from "../runtime";

const sv_description = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Beskrivning`
};

const description = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_description(inputs)
	return "description";
};

export { description as "description" };